import type { ToolModule } from '../../core/modules/types'
import { StockTransferView } from './view'

export const stockTransferModule: ToolModule = {
  id: 'stock-transfer',
  title: 'Stock Transfer (Portal)',
  description: 'One click on the staging portal: new devices into the Production Line, then dispatched transfers to a shop for the app to receive — mixed device types, singly or in bulk, with a barcode sheet of every IMEI.',
  requiresToken: false,
  View: StockTransferView,
}
